import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/iso_blanco.svg'
import _imports_1 from '../../assets/castellano.jpg'
import _imports_2 from '../../assets/ingles.jpg'
import _imports_3 from '../../assets/portugues.jpg'


const _hoisted_1 = { class: "languages-l" }

import { ref } from 'vue';

import { useI18n } from 'vue-i18n';

// Usar la instancia de i18n

export default /*@__PURE__*/_defineComponent({
  __name: 'MobileMenu',
  setup(__props) {

const isMenuOpen = ref(false);

function toggleMenu() {
  isMenuOpen.value = !isMenuOpen.value;
}
function closeMenu() {
  isMenuOpen.value = false;
}

const { locale } = useI18n();

// Función para cambiar el idioma
const changeLocale = (lang: string) => {
  locale.value = lang;  // Cambiar el idioma de la aplicación
  localStorage.setItem('locale', lang); // Guardar el idioma seleccionado en localStorage
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: _normalizeClass(["hamburger", { open: isMenuOpen.value }]),
      onClick: toggleMenu
    }, _cache[3] || (_cache[3] = [
      _createElementVNode("span", null, null, -1),
      _createElementVNode("span", null, null, -1),
      _createElementVNode("span", null, null, -1)
    ]), 2),
    _createElementVNode("nav", {
      class: _normalizeClass(["mobile-menu", { open: isMenuOpen.value }])
    }, [
      _cache[8] || (_cache[8] = _createElementVNode("img", {
        class: "white-logo",
        src: _imports_0,
        alt: "",
        width: "30px"
      }, null, -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/#home",
            onClick: closeMenu
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("HOME")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/#operator",
            onClick: closeMenu
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("FUNCIONAMIENTO")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/#technical-data",
            onClick: closeMenu
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("DATOS TÉCNICOS")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/#contacto",
            onClick: closeMenu
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("CONTACTO")
            ])),
            _: 1
          })
        ])
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "slash" }, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "languages",
          src: _imports_1,
          alt: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeLocale('es')))
        }),
        _createElementVNode("img", {
          class: "languages",
          src: _imports_2,
          alt: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLocale('en')))
        }),
        _createElementVNode("img", {
          class: "languages",
          src: _imports_3,
          alt: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (changeLocale('pt')))
        })
      ])
    ], 2)
  ]))
}
}

})